export default "__VITE_ASSET__DZaVH5OM__"